import { useState, useEffect } from 'react';
import { enterpriseApi } from '../services/enterprise.api';

export function useEnterpriseBranding() {
  const [enterpriseName, setEnterpriseName] = useState<string>('K-Store');
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const loadBranding = async () => {
      try {
        const response = await enterpriseApi.getConfig();
        const name = response.data?.name || 'K-Store';
        setEnterpriseName(name);

        // Mettre à jour le title de la page
        document.title = `${name} - Backoffice`;
      } catch (error) {
        console.error('Erreur chargement branding:', error);
        // Utiliser K-Store par défaut en cas d'erreur
        setEnterpriseName('K-Store');
        document.title = 'Backoffice';
      } finally {
        setIsLoading(false);
      }
    };

    loadBranding();
  }, []);

  return { enterpriseName, isLoading };
}
